<template>
  <div class="product-recommendations-card-small">
    <a class="product-recommendations-card-small__image-container" :href="productUrl">
      <ImageContentful
        :src="imageUrl"
        :options="{
          imageCompression: 61,
          fixedWidth: imageSize,
          fixedHeight: imageSize,
          format: CONTENTFUL_IMAGE_FORMAT.jpg,
          backgroundColor,
        }"
        :alt="item.name"
      />
    </a>
    <div class="product-recommendations-card-small__description">
      <a class="product-recommendations-card-small__title" :href="productUrl">{{ item.name }}</a>
      <div class="product-recommendations-card-small__color">
        {{ recommendedVariant.colorName }}
      </div>
      <div class="product-recommendations-card-small__price">
        {{ recommendationPrice }}
      </div>
    </div>
    <QuickAdd
      :variant="recommendedVariant"
      :productSubtype="productSubtype"
      :modifier="MODIFIER.round"
      :context="context"
      @select-size="$emit('select-size', { item })"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { CONTENTFUL_IMAGE_FORMAT } from '@/components/_shared/ImageContentful.vue'
import { formatToCurrency } from '@/helpers/currency-formatter'
import ImageContentful from '@/components/_shared/ImageContentful.vue'
import QuickAdd from '@/components/_shared/QuickAdd/QuickAdd.vue'
import { MODIFIER } from '@/components/_shared/QuickAdd/QuickAddButton.vue'
import { backgroundColor, imageSize } from './ProductRecommendationsMiniCard.module.scss'

export default {
  name: 'ProductRecommendationsCardSmall',
  components: {
    QuickAdd,
    ImageContentful,
  },

  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    context: {
      type: String,
    },
  },

  data() {
    return {
      backgroundColor,
      CONTENTFUL_IMAGE_FORMAT,
      hasLoadedRecImage: true,
      imageSize: parseFloat(imageSize),
      MODIFIER,
    }
  },

  computed: {
    ...mapState({
      currency: state => state.store.currency,
      locale: state => state.page.locale,
    }),

    recommendedVariant() {
      const { item } = this
      return item.variants.find(variant => variant.id === item.displayedVariantId) || {}
    },

    productSubtype() {
      return this.productData.productSubtype
    },

    recommendationPrice() {
      const amount = Number(this.item.price)
      return formatToCurrency(amount, this.locale, this.currency)
    },

    imageUrl() {
      return this.recommendedVariant.imageUrl || ''
    },

    productUrl() {
      return this.recommendedVariant.productUrl
    },
  },
}
</script>

<style lang="scss" scoped>
@import './ProductRecommendationsMiniCard.module.scss';

.product-recommendations-card-small {
  padding: $site-gutter;
  text-align: center;
  background-color: $background-color;
  display: flex;
  align-items: center;
  flex: 1;

  @media ($mq-high) {
    margin-bottom: 0;
    padding: 28px;
  }

  &__description {
    flex: 1;
    text-align: left;
  }

  &__image-container {
    width: $image-size;
    height: $image-size;
    margin-right: $site-gutter;
  }

  &__title {
    display: inline-block;
    margin-bottom: 2px;
    color: $color-text;
    letter-spacing: $font-spacing-small;
  }

  &__color,
  &__price {
    font-size: $font-size-small;
    line-height: space(5, $font-size-small);
    letter-spacing: $font-spacing-small;
    color: $color-grey-mid-3;
  }
}
</style>
